// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3jVpg","label":"Labeled_label__4CCzj","divider":"Labeled_divider__7FdmS"};